module.exports = __webpack_public_path__ + "static/media/slide-1.27c05227.png";